/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import boxCommonStyle from "@/src/components/Serviceworld/Common/boxCommonStyle";

const processStepStyle = {
  ...boxCommonStyle,
  textBlock: {
    marginTop: "10px",
    marginBottom: "10px",
    minHeight: "4rem",
  },
  stepHeading: {
    fontWeight: 500,
  },
  iconContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    alignContent: "center",
    alignItems: "center",
    marginLeft: "0.25rem",
  },
  connectorLine: {
    flexGrow: 1,
    borderLeft: "1px solid",
    borderColor: "iconColor.main",
  },
  connectorLineInvisible: {
    flexGrow: 1,
  },
  progressIcons: {
    margin: "5px 0",
    "& img": {
      width: "40px",
    },
  },
  imageCircle: {
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    width: "40px",
    height: "40px",
    padding: "12px",
    borderRadius: "50% !important",
    border: "1px solid #333",
  },
  img: {
    maxHeight: "24px",
  },
};

export default processStepStyle;
